module.exports = __webpack_public_path__ + "static/media/Krishna-Pooja-1024x681.d9936b99.jpg";